import React from "react";

function HomeOpening() {
  const [visible, setVisible] = React.useState(true);

  React.useEffect(() => {
    const timer = window.setTimeout(() => setVisible(false), 2600);
    return () => window.clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <div className="home-opening" aria-label="NEXT INNOVATIONS opening message">
      <div className="home-opening-grid" aria-hidden="true" />
      <div className="home-opening-beam" aria-hidden="true" />

      <div className="home-opening-inner">
        <div className="home-opening-kicker mono">NEXT INNOVATIONS · AI & PRODUCT DEVELOPMENT</div>
        <p className="home-opening-title">
          <span>AI that multiplies</span>
          <span>business value.</span>
        </p>
        <div className="home-opening-line" aria-hidden="true" />
        <div className="home-opening-tags mono">
          <span>STRATEGY</span>
          <span>SYSTEMS</span>
          <span>PRODUCTS</span>
          <span>AUTOMATION</span>
        </div>
      </div>
    </div>
  );
}

export { HomeOpening };
